/**
 * Calculates the progress percentage for a multi-phase questionnaire
 * @param currentStep - The current step within the current phase (0-indexed)
 * @param stepOffset - The number of steps from previous phases
 * @param totalSteps - Total number of steps across all phases
 * @returns Progress percentage (0-100)
 */
export function calculateProgressValue(
  currentStep: number,
  stepOffset: number,
  totalSteps: number
): number {
  if (totalSteps <= 0) return 0;
  return ((stepOffset + currentStep + 1) / totalSteps) * 100;
}

/**
 * Calculates the progress percentage for an overview/non-step state
 * Shows progress up to the beginning of the current phase
 * @param stepOffset - The number of steps from previous phases
 * @param totalSteps - Total number of steps across all phases
 * @returns Progress percentage (0-100)
 */
export function calculateOverviewProgressValue(stepOffset: number, totalSteps: number): number {
  if (totalSteps <= 0) return 0;
  return (stepOffset / totalSteps) * 100;
}
